import { toBlob } from "html-to-image";

export class HTMLToImage {
    constructor() {}

    /**
     *
     * @param {Object} element - DOM element to convert to PNG.
     * @returns {Promise} - Promise that resolves to a PNG image data URL.
     * @memberof HTMLToImage
     * @method toBlob
     * @public
     * @example
     * HTMLToImage.toBlob({ element: document.querySelector("body"), options: {} });
     */
    async toBlob({ element, options = {} } = {}) {
        return await toBlob(element, options);
    }
}
